import * as React from 'react';
import global from '@applications';
import './style.less';

export interface ICardProps {
    uiid: string;
}

function CardWrapper<P extends ICardProps>(
    Component: React.FunctionComponent<P> | React.ComponentClass<P>
) {
    const wrappedComponent: React.FunctionComponent<P> = (props: P) => {
        const isRedesignTilesPhase1 =
      global &&
      global.applications &&
      global.applications.Platform &&
      global.applications.Platform.redesignDataRichTiles;

        const isRedesignTilesPhase2 =
      global &&
      global.applications &&
      global.applications.Platform &&
      global.applications.Platform.redesignTilesPhase2;

        const dynamicStyleClass = isRedesignTilesPhase2
            ? 'tc-srm-redesigned-dashboard-panel-424px'
            : isRedesignTilesPhase1
                ? 'tc-srm-redesigned-dashboard-panel'
                : '';
        return (
            <div className={`panel panel-default ${props.uiid} ${dynamicStyleClass}`}>
                <Component {...props} />
            </div>
        );
    };

    wrappedComponent.displayName = 'CardWrapper';
    return wrappedComponent;
}

export default CardWrapper;
